import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Build query params for dashboard data endpoints from the shared filter state.
export function filterParams(filters, { includeRange = true } = {}) {
  const p = {};
  if (filters.user) p.user = filters.user;
  if (filters.model) p.model = filters.model;
  if (filters.session) p.session = filters.session;
  if (filters.token) p.token = filters.token;
  if (includeRange) {
    if (filters.range === "custom") {
      if (filters.from) p.from = filters.from;
      if (filters.to) p.to = filters.to;
      p.range = "week"; // bucket fallback when custom dates incomplete
    } else {
      p.range = filters.range;
    }
  }
  return p;
}

export const filterKey = (filters) => [
  filters.range, filters.from, filters.to,
  filters.user, filters.model, filters.session, filters.token,
];
